import React from 'react';
import PropTypes from 'prop-types';
import InputLabel from '@hobs/components/InputLabel';
import classNames from 'classnames';
import { WithErrorLabel } from '@hobs/components/FormError';
import Styles from './Textarea.module.scss';

const Textarea = ({
  field,
  children,
  label,
  placeholder,
  maxLength,
  disabled = false,
  borderless = false,
  indicationMessage,
  ...rest
}) => {
  return (
    <div
      className={classNames(
        { [Styles.borderless]: borderless },
        Styles.textarea,
        'stop-drag'
      )}
    >
      {label && (
        <InputLabel indicationMessage={indicationMessage}>{label}</InputLabel>
      )}
      <textarea
        placeholder={placeholder}
        disabled={disabled}
        maxLength={maxLength}
        {...field}
        {...rest}
      >
        {children}
      </textarea>
    </div>
  );
};

Textarea.propTypes = {
  label: PropTypes.string,
  field: PropTypes.object,
  form: PropTypes.object,
  placeholder: PropTypes.string,
  maxLength: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool,
  borderless: PropTypes.bool,
  children: PropTypes.any,
  indicationMessage: PropTypes.object
};

export default WithErrorLabel(Textarea);
